import { useTranslation } from 'react-i18next';
import { TableData } from '@anytag/shared-types';
import { useTableMaxHeight } from '@anytag/shared-hooks';
import { InstagramHashtagFeedPostV2 } from '@anytag/graphql';
import { RenderDataWithFallback, Switch, TableV2 } from '@anytag/shared-atoms';
import { InstagramHashtagPostDetailsModal } from '@anytag/shared-molecules';
import { ProfilePostsCount } from '../../../../ProfilePostsList';
import { useAnalyticsInstagramHashtagsFilter } from '../AnalyticsInstagramHashtagsFilter';
import { useAnalyticsInstagramHashtagPostsListTable } from './hooks';

export type AnalyticsInstagramHashtagPostsListProps = TableData<InstagramHashtagFeedPostV2>;

export const AnalyticsInstagramHashtagPostsList = ({
  loading,
  data = [],
  totalRecords
}: AnalyticsInstagramHashtagPostsListProps) => {
  const { t } = useTranslation();
  const { filter, setFilter } = useAnalyticsInstagramHashtagsFilter();
  const { offsetRef, defaultTableMaxHeight } = useTableMaxHeight();
  const { columns } = useAnalyticsInstagramHashtagPostsListTable();

  return (
    <RenderDataWithFallback loading={loading}>
      <ProfilePostsCount count={totalRecords} className="shadow-none" alwaysShow>
        <Switch label={t('UGC only')} checked={filter.ugc} onChange={() => setFilter({ ugc: !filter.ugc })} />
      </ProfilePostsCount>
      <TableV2
        ref={offsetRef}
        maxHeight={defaultTableMaxHeight}
        data={data}
        columns={columns}
        rowHeight="72px"
        noTopBorderRadius
        stickyHeader
      />
      <InstagramHashtagPostDetailsModal posts={data.map(({ id }) => ({ id }))} />
    </RenderDataWithFallback>
  );
};
